mutation InvoiceBatchDelete(
  $input: InvoiceBatchDeleteInput!
  $batchInputId: UUID!
) {
  invoiceBatchDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
    query {
      batchTransaction(id: $batchInputId) {
        _companyId
        _batchTransactionCount
        _batchTransactionTotal
      }
    }
  }
}
